export enum SettingsPaths {
  AUKSION_SETTING = "/auksion-setting",
  ADMIN_SETTING = "/admin-setting",
  KOMPANY_SETTING = "/kompany-setting",
  KATEGORY_SETTING = "/kategory-setting",
}
